import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {Box, TextField, TextFieldProps, Tooltip, Typography} from '@mui/material';
import {forwardRef} from 'react';
export type AppInputProps = TextFieldProps & {
    descriptionText?: string;
};

export const AppInput = forwardRef<HTMLDivElement, AppInputProps>(
    ({label, descriptionText, required, ...rest}, ref) => {
        return (
            <Box display={'flex'} flexDirection={'column'}>
                <Box display={'flex'} alignItems={'center'}>
                    <Typography variant="body2" style={{marginBottom: '5px'}}>
                        {label} {required && <span style={{color: 'red'}}>*</span>}
                    </Typography>
                    {descriptionText && (
                        <Box ml={0.5}>
                            <Tooltip title={descriptionText} placement="top" arrow>
                                <HelpOutlineIcon color="primary" fontSize="small" />
                            </Tooltip>
                        </Box>
                    )}
                </Box>
                <TextField inputRef={ref} variant="outlined" size="small" {...rest} />
            </Box>
        );
    },
);

AppInput.displayName = 'AppInput';

export default AppInput;
